import { useLocalization } from "@fluent/react";
import { useCallback } from "react";

export default function useCheckNumberValidation() {
  const { l10n } = useLocalization();

  const validateCheckNumberField = useCallback(
    (value: string) => {
      if (!value) {
        return l10n.getString("error-required", {}, "Required");
      }
      if (!/^[0-9]+$/.test(value)) {
        return l10n.getString(
          "error-check-number-digits-only",
          {},
          "Must be only digits",
        );
      }
      return null;
    },
    [l10n],
  );

  const validateAmountField = useCallback(
    (value: string | null) => {
      if (!value || value === "$") {
        return l10n.getString("error-required", {}, "Required");
      }
      const numericValue = parseFloat(value.replace(/[$,]/g, ""));
      if (Number.isNaN(numericValue) || numericValue <= 0) {
        return l10n.getString(
          "error-amount-positive",
          {},
          "Amount must be greater than zero",
        );
      }
      return null;
    },
    [l10n],
  );

  return { validateCheckNumberField, validateAmountField };
}
